import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '../../app/store';
import { Mob } from '../../models/mob';

const initialState: MobsState = {
  query: '',
  mobs: []
};

export interface MobsState {
  query: string;
  mobs: any[];
}

export const slice = createSlice({
  name: 'mobs',
  initialState,
  reducers: {
    setQuery: (state, action: PayloadAction<string>) =>{
      state.query = action.payload;
    },
    queryMobsFulfilled: (state, action: PayloadAction<Mob[]>) => {
      state.mobs = action.payload;
    },
  }
});

export const queryMobs = (): AppThunk<Promise<Mob[]>> => async (dispatch) => {  
  let url = 'https://wotcodeapi.azurewebsites.net/api/smobs';
  const queryParams = new URLSearchParams(window.location.search);
  if (queryParams.get('admin')) {
    url += '?admin=true';
  }
  
  const results = await fetch(url).then(resp => resp.json()) as Mob[];
  for (let result of results) {
    for (let key of Object.keys(result.items)) {
      result.items[key] = Math.round(result.items[key] / result.total * 100)
      result.sortedItems = Object.entries(result.items).sort(([, a], [, b]) => a - b).map(([key, val]) => ({key, val}));
    }
  }

  dispatch(slice.actions.queryMobsFulfilled(results));
  return results;
};


export default slice.reducer;
export const { setQuery } = slice.actions;